<template>
  <div
    @click="handleClick"
    class="msg-screen -helper--flex align-center"
    :class="this.userMessageContext.popupAlignmentClass ? this.userMessageContext.popupAlignmentClass : 'justify-center'"
  >
    <component :is="activePopup" :popupProps="popupTypeProps" />
  </div>
</template>
<script>
export default {
  computed: {
    userMessageContext () {
      return this.$store.getters['errors/getUserMessage']
    },
    popupType () {
      return this.userMessageContext.popupType
    },
    popupTypeProps () {
      return this.userMessageContext.popupTypeProps
    },
    activePopup () {
      return () => import(`./${this.popupType}.vue`)
    }
  },
  methods: {
    handleClick () {
      if (['NewlyFormedBusiness', 'RequiredDocExample'].includes(this.popupType)) {
        this.terminateUserMessage()
      }
    },
    terminateUserMessage () {
      this.$store.commit('errors/updateUserMessage', {
        isActive: false,
        popupType: '',
        popupAlignmentClass: 'justify-center'
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/globalUiComponents/userMessage/UserMessage.vue